import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classnames from 'classnames';
import { Column, FlexColumn, FlexRow, Row, ServicingSection } from 'web-ui-components/lib/global/layout';
import { Label } from 'web-ui-components/lib/atoms/forms';
import { LoadingLocalTakeover } from 'web-ui-components/lib/organisms/takeovers';
import { TYPE_FASTER_PAYMENTS } from '../../../config';
import { CONST_FILE_UPLOAD } from '../../../config/constants';
import withContent from '../../../containers/withContent';
import { withScrollTop } from '../../../containers/withScrollTop';
import withAccountSelection from '../../../containers/withAccountSelection';
import pageContent, { contentPropTypes } from '../Payments/payment.content';
import { FromAccount } from '../../../sharedComponents/FromAccount/FromAccount';
import { ToAccount } from '../../../sharedComponents/ToAccount/ToAccount';
import SiteHeader from '../../../sharedComponents/SiteHeader/SiteHeader';
import PaymentTabs from '../../../paymentAppSelector/PaymentTabs';
import Notifications from '../../../sharedComponents/Notifications';
import { toAccountPropType, fromAccountPropType } from '../../../states/accounts/propTypes';
import { payeePropTypes } from '../../../sharedComponents/PayeeList/propTypes';
import { resetApp, goToPage, pages } from '../../../states/page/actions';
import { createFasterPaymentTemplate } from '../../../states/payments/actions';
import { getPayees } from '../../../states/payees/selectors';
import { getFirstPayment } from '../../../states/payments/selectors';
import { getTemplateListByType } from '../../../states/templates/selectors';
import { fetchTemplates, selectPaymentTemplate, editPaymentTemplate } from '../../../states/templates/actions';
import TemplateSelector from '../../../sharedComponents/TemplateSelector/TemplateSelector';
import { connectWrapper as FileUploadRevealBlock } from '../FileUploadRevealBlock';
import { getSelectedFromAccount } from '../../../states/payeeSelector/selectors';
import FileUploadFeatureFlag from '../../../sharedComponents/FileUploadFeatureFlag/FileUploadFeatureFlag';
import { StandardLabel } from 'web-ui-components/lib/typography/labels';

const mapState = (state) => ({
	toPayees: getPayees(state),
	firstPayment: getFirstPayment(state),
	templates: getTemplateListByType(state, TYPE_FASTER_PAYMENTS),
	fromAccount: getSelectedFromAccount(state),
});

const mapDispatch = (dispatch) => ({
	createNewTemplate: () => dispatch(createFasterPaymentTemplate()),
	fetchTemplates: () => dispatch(fetchTemplates()),
	reset: () => dispatch(resetApp),
	handleSelectTemplate: (id) => dispatch(selectPaymentTemplate(id)),
	handleEditTemplate: (id, name) => dispatch(editPaymentTemplate(id, name)),
	goToPayeeSelector: () => dispatch(goToPage(pages.FasterPaymentsPayeeSelector)),
});

class PaymentsLandingPage extends Component {
	constructor(props) {
		super(props);

		this.handleToCardClick = this.handleToCardClick.bind(this);
	}

	componentDidMount() {
		const { reset, fetchTemplates } = this.props;
		reset();
		fetchTemplates();
	}

	handleToCardClick() {
		this.props.goToPayeeSelector();
	}

	render() {
		const {
			handleSelectPaymentType,
			toPayees,
			fromAccounts,
			toAccounts,
			content,
			content: { header, fromLabel, toLabel, subHeader },
			showPaymentTabs,
			createNewTemplate,
			isBootStrapInProgress,
			showFromAccountSelector,
			fromAccount,
			handleSelectFromAccount,
			handleFromCardClick,
		} = this.props;

		const wrapperClass = classnames({
			'c-o-payee-list--from-state': showFromAccountSelector,
		});

		return (
			<div className={wrapperClass}>
				<SiteHeader title={header} />
				<LoadingLocalTakeover show={isBootStrapInProgress} title="loading...">
					<ServicingSection>
						{showPaymentTabs && (
							<div>
								<div className="u-margin-bottom-2">
									<PaymentTabs activeTab={TYPE_FASTER_PAYMENTS} handleSelectTab={handleSelectPaymentType} />
								</div>
								<div className="u-margin-bottom-2">
									<Notifications />
								</div>
							</div>
						)}
						<p>{subHeader}</p>
						<Row>
							<Column md={12}>
								<FlexRow>
									<FlexColumn gutter={1}>
										<StandardLabel>
											<span>{fromLabel}</span>
										</StandardLabel>
										<FromAccount
											id="fromAccount"
											fromAccount={fromAccount}
											showAccountSelector={showFromAccountSelector}
											fromAccounts={fromAccounts}
											handleSelectFromAccount={handleSelectFromAccount}
											handleCardClick={handleFromCardClick}
										/>
									</FlexColumn>
									<FlexColumn gutter={1}>
										<StandardLabel>
											<span>{toLabel}</span>
										</StandardLabel>
										<ToAccount
											id="toAccount"
											handleCardClick={this.handleToCardClick}
											showAccountSelector={false}
											toPayees={toPayees}
											toAccounts={toAccounts}
											fromAccount={fromAccount}
											disable={!fromAccount}
										/>
									</FlexColumn>
								</FlexRow>
							</Column>
						</Row>
						<TemplateSelector paymentType={TYPE_FASTER_PAYMENTS} handleCreateNewTemplate={createNewTemplate} />
						<FileUploadFeatureFlag path={CONST_FILE_UPLOAD.FPS}>
							<FileUploadRevealBlock fromAccounts={fromAccounts} content={content} type={TYPE_FASTER_PAYMENTS} />
						</FileUploadFeatureFlag>
					</ServicingSection>
				</LoadingLocalTakeover>
			</div>
		);
	}
}

PaymentsLandingPage.propTypes = {
	showPaymentTabs: PropTypes.bool.isRequired,
	content: PropTypes.shape(contentPropTypes).isRequired,
	handleSelectPaymentType: PropTypes.func.isRequired,
	toAccounts: PropTypes.arrayOf(PropTypes.shape(toAccountPropType)).isRequired,
	fromAccounts: PropTypes.arrayOf(PropTypes.shape(fromAccountPropType)).isRequired,
	toPayees: PropTypes.arrayOf(PropTypes.shape(payeePropTypes)).isRequired,
	createNewTemplate: PropTypes.func.isRequired,
	fetchTemplates: PropTypes.func,
	isBootStrapInProgress: PropTypes.bool.isRequired,
	goToPayeeSelector: PropTypes.func.isRequired,
	showFromAccountSelector: PropTypes.bool.isRequired,
	handleSelectFromAccount: PropTypes.func.isRequired,
	handleFromCardClick: PropTypes.func.isRequired,
	reset: PropTypes.func.isRequired,
	fromAccount: PropTypes.string,
};

export const connectWrapper = connect(mapState, mapDispatch)(PaymentsLandingPage);
const contentWrapper = withContent({ content: pageContent });
export default withScrollTop(contentWrapper(withAccountSelection(connectWrapper)));
